import React, { useState, useEffect } from 'react';
import axios from 'axios';

const AbsenPengayaan = () => {
  const [pengayaanList, setPengayaanList] = useState([]);
  const [selectedPengayaan, setSelectedPengayaan] = useState('');
  const [tanggal, setTanggal] = useState(new Date().toISOString().split('T')[0]);
  
  const [siswaList, setSiswaList] = useState([]);
  const [absensi, setAbsensi] = useState({});
  const [loading, setLoading] = useState(false);

  const API_URL = 'http://localhost:10000/api'; // Sesuaikan IP VPS / URL API kamu

  useEffect(() => {
    fetchPengayaan();
  }, []);

  useEffect(() => {
    if (selectedPengayaan) {
      fetchSiswaAndAbsensi();
    }
  }, [selectedPengayaan, tanggal]);

  const fetchPengayaan = async () => {
    try {
      const res = await axios.get(`${API_URL}/pengayaan`);
      setPengayaanList(res.data);
      if (res.data.length > 0) setSelectedPengayaan(res.data[0].id);
    } catch (err) { console.error(err); }
  };

  const fetchSiswaAndAbsensi = async () => {
    setLoading(true);
    try {
      // 1. Ambil daftar anggota kelompok pengayaan
      const resSiswa = await axios.get(`${API_URL}/pengayaan/${selectedPengayaan}/anggota`);
      setSiswaList(resSiswa.data);

      // 2. Ambil data absensi tersimpan
      const resAbsen = await axios.get(`${API_URL}/absensi-pengayaan`, {
        params: { kelompok_id: selectedPengayaan, tanggal }
      });

      const initialMap = {};
      resSiswa.data.forEach(s => {
        initialMap[s.id] = 'Hadir'; // Default Hadir
      });

      if (resAbsen.data && resAbsen.data.length > 0) {
        resAbsen.data.forEach(item => {
          initialMap[item.siswa_id] = item.status;
        });
      }

      setAbsensi(initialMap);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = (siswaId, status) => {
    setAbsensi(prev => ({ ...prev, [siswaId]: status }));
  };

  const handleSimpan = async () => {
    if (!selectedPengayaan) return alert('Pilih kelompok pengayaan terlebih dahulu');
    try {
      const payload = {
        kelompok_id: selectedPengayaan,
        tanggal,
        absensi: Object.keys(absensi).map(siswaId => ({
          siswa_id: parseInt(siswaId),
          status: absensi[siswaId]
        }))
      };

      await axios.post(`${API_URL}/absensi-pengayaan`, payload);
      alert('Absensi pengayaan berhasil disimpan!');
    } catch (err) {
      alert('Gagal menyimpan absensi pengayaan');
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <h2>📖 Absensi Kelompok Pengayaan</h2>

      <div style={{ display: 'flex', gap: '15px', marginBottom: '20px', flexWrap: 'wrap' }}>
        <div>
          <label style={{ display: 'block', marginBottom: '5px' }}>Kelompok Pengayaan:</label>
          <select value={selectedPengayaan} onChange={(e) => setSelectedPengayaan(e.target.value)} style={{ padding: '8px' }}>
            {pengayaanList.map(p => (
              <option key={p.id} value={p.id}>{p.nama_kelompok} ({p.mapel})</option>
            ))}
          </select>
        </div>

        <div>
          <label style={{ display: 'block', marginBottom: '5px' }}>Tanggal:</label>
          <input type="date" value={tanggal} onChange={(e) => setTanggal(e.target.value)} style={{ padding: '8px' }} />
        </div>
      </div>

      {loading ? (
        <p>Memuat data siswa...</p>
      ) : (
        <>
          <table border="1" cellPadding="10" style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
            <thead>
              <tr style={{ background: '#f4f4f4' }}>
                <th>No</th>
                <th>Nama Siswa</th>
                <th>Kelas asal</th>
                <th>Status Kehadiran</th>
              </tr>
            </thead>
            <tbody>
              {siswaList.length > 0 ? (
                siswaList.map((siswa, idx) => (
                  <tr key={siswa.id}>
                    <td>{idx + 1}</td>
                    <td>{siswa.nama}</td>
                    <td>{siswa.kelas}</td>
                    <td>
                      {['Hadir', 'Izin', 'Sakit', 'Alpha'].map(status => (
                        <label key={status} style={{ marginRight: '15px', cursor: 'pointer' }}>
                          <input
                            type="radio"
                            name={`status-${siswa.id}`}
                            value={status}
                            checked={absensi[siswa.id] === status}
                            onChange={() => handleStatusChange(siswa.id, status)}
                          />
                          {status}
                        </label>
                      ))}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" style={{ textAlign: 'center' }}>Belum ada anggota di kelompok ini.</td>
                </tr>
              )}
            </tbody>
          </table>

          {siswaList.length > 0 && (
            <button onClick={handleSimpan} style={{ marginTop: '20px', padding: '10px 20px', cursor: 'pointer' }}>
              💾 Simpan Absensi
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default AbsenPengayaan;